var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"action",attrs:{"aria-label":_vm.$t('sidebar.newFile'),"title":_vm.$t('sidebar.newFile'),"id":"new-file-button"},on:{"click":_vm.newFile}},[_c('file-plus-icon',{staticClass:"custom-class",attrs:{"size":"1.5x"}}),_c('span',[_vm._v(_vm._s(_vm.$t('sidebar.newFile')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }